import React from 'react';
import classes from './Spinner.module.css';

const Spinner = (props) => {

    return (
        <div className={props.type === 2 ? classes.ldsDualRing2 : classes.ldsDualRing}></div>
    )
}


export default Spinner;